import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import DIGITAL_WALLETS_PROPS from './constants';

const AcceleratedPaymentMethods = ({ supportedDigitalWallets, checkoutUrl, onLinkClick }) => {
  const digitalWalletsWithProps = supportedDigitalWallets.map(
    digitalWalleKey => DIGITAL_WALLETS_PROPS[digitalWalleKey]
  );

  return (
    <div className="AcceleratedPaymentMethods">
      <ul className="AcceleratedPaymentMethods__list">
        {digitalWalletsWithProps.map(({ logo, altText, backgroundColor, analyticsKey }) => (
          <li
            className={classNames('AcceleratedPaymentMethods__item', {
              [`AcceleratedPaymentMethods__item--${analyticsKey}`]: analyticsKey,
            })}
            style={{ backgroundColor }}
            key={altText}
          >
            <a
              className="AcceleratedPaymentMethods__link"
              href={checkoutUrl}
              onClick={() =>
                onLinkClick({
                  alt: altText,
                  url: checkoutUrl,
                  name: analyticsKey,
                })
              }
            >
              <img alt={altText} className="AcceleratedPaymentMethods__logo" src={logo} />
            </a>
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .AcceleratedPaymentMethods {
            position: relative;
          }

          .AcceleratedPaymentMethods__list {
            display: flex;
            justify-content: space-between;
            gap: ${Theme.get('spacing-px')};
          }

          .AcceleratedPaymentMethods__link {
            position: relative;
            display: block;
            width: 100%;
            height: 100%;
            display: flex;
            place-content: center;
          }

          .AcceleratedPaymentMethods__item {
            text-align: center;
            padding: ${Theme.get('spacing-px')} 0;
            border-radius: ${Theme.get('border-radius')}px;
            min-height: 18px;
            width: 100%;
            transition: box-shadow 0.1s ${Theme.get('transition-timing-ease-in-out-sine')};
          }

          .AcceleratedPaymentMethods__item:hover {
            box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);
          }

          .AcceleratedPaymentMethods__logo {
            max-height: 16px;
            position: relative;
            width: 70%;
            top: 2px;
            object-fit: contain;
          }

          // Google Pay logo is taller than the others, adjusting the height so logo doesn't look smaller
          // position absolute to not affect the row height
          .AcceleratedPaymentMethods__item--gpay .AcceleratedPaymentMethods__logo {
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            top: 0;
            bottom: 2px;
            max-height: 20px;
          }
        `}
      </style>
    </div>
  );
};

AcceleratedPaymentMethods.propTypes = {
  supportedDigitalWallets: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkoutUrl: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired,
};

export default AcceleratedPaymentMethods;
